const VideoTutorial = ({ color }) => {
    return (
        <svg 
             width="24"
             height="21" 
             viewBox="0 0 24 21" 
             fill="none" 
             xmlns="http://www.w3.org/2000/svg">
        <path 
            d="M11.9669 1.00055L12 0.999453L12.0331 1.00055L13.8623 1.06105C14.1085 1.06919 14.3521 1.08669 14.5931 1.11321L19.5359 1.33084C20.6299 1.34024 21.5174 1.98109 22.0917 2.80532C22.6726 3.63916 23 4.73735 23 5.90272V10.506V15.1634C23 16.3288 22.6726 17.427 22.0917 18.2608C21.5166 19.0863 20.6273 19.7278 19.531 19.7353L14.4348 19.9149C14.2251 19.9344 14.0134 19.9471 13.7999 19.9527L12.0264 19.9997L12 20.0004L11.9735 19.9997L10.2001 19.9527C9.98661 19.9471 9.77491 19.9344 9.56524 19.9149L4.46897 19.7353C3.37271 19.7278 2.48341 19.0863 1.90834 18.2608C1.32744 17.427 1 16.3288 1 15.1634V10.506V5.90272C1 4.73735 1.32744 3.63916 1.90834 2.80532C2.48256 1.98109 3.37007 1.34024 4.4641 1.33084L9.40695 1.11321C9.64785 1.08669 9.89155 1.06919 10.1377 1.06105L11.9669 1.00055Z"
            stroke={color} 
            strokeWidth="2"/>
        <path 
            d="M16.5 9.13398C17.1667 9.51888 17.1667 10.4811 16.5 10.866L9 15.1962C8.33333 15.5811 7.5 15.0999 7.5 14.3301L7.5 5.66987C7.5 4.90007 8.33333 4.41895 9 4.80385L16.5 9.13398Z" 
            fill={color}/>
        </svg>
        
        
    );
  };
  
  export default VideoTutorial;

  
  